import React from "react";
import PropTypes from "prop-types";
import "./basic-button.css";

function Button(props) {
  const {
    classname, disable, onClick, buttonText,
  } = props;
  return (
    <div
      role="button"
      className={`${classname || "button-container"} ${disable ? "disbaledStyle" : ""}`}
      onClick={!disable ? onClick : undefined}
      onKeyDown={() => {
        // onKeyDown
      }}
      tabIndex="0"
    >
      <a className="button">
        {" "}
        <span />
        <span>{buttonText}</span>
      </a>
    </div>
  );
}

Button.defaultProps = {
  classname: "",
  buttonText: "",
  onClick: () => {
    // onClick
  },
  disable: false,
};
Button.propTypes = {
  classname: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  disable: PropTypes.bool,
};
export default Button;
